module.exports = __webpack_public_path__ + "static/img/fj2.12bfe5c3.png";